import { Component } from '@angular/core';
import { NavController, NavParams,AlertController, ActionSheetController, ToastController, Platform, LoadingController, Loading } from 'ionic-angular';

import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
//import { Http, Headers, RequestOptions } from '@angular/common/http';



import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { GlobalProvider } from "../../providers/global/global";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {BaseRequestOptions, RequestOptions, Headers, RequestOptionsArgs} from "@angular/http";
import { ImageBrowserUploadProvider } from '../../providers/image-browser-upload/image-browser-upload';

import { ImagePicker } from '@ionic-native/image-picker';
import { Base64 } from '@ionic-native/base64';
import { File } from '@ionic-native/file';
import { Transfer, TransferObject } from '@ionic-native/transfer';
import { FilePath } from '@ionic-native/file-path';
import { Camera } from '@ionic-native/camera';

import { VisitorsRegMorePage } from '../visitors-reg-more/visitors-reg-more';
import { LoginPage } from '../login/login';

declare var cordova: any;

@Component({
  selector: 'page-visitors-reg',
  templateUrl: 'visitors-reg.html'
})
export class VisitorsRegPage {
  private vistor_reg : FormGroup;
  lastImage: string = null;
  loading: Loading;


  confirmPass:boolean = false;
  isparking:boolean = false;
  iswifi:boolean = false;
  iswheelChair:boolean = false;
  items:any;

  disclaimer = false;
 

  imgPreview = './assets/imgs/upload.jpeg';
  regData = { avatar:'', name: '', surname: '', id_passport: '', email: '',mnumber: '', carreg:'', carmodel:'', carmake:'', company:'' };
  title = "Mr";
  fname = "";
  surname = "";
  id_type = "ID";
  id_passport = "";
  mnumber = "";
  email = "";
  password = "";
  cpassword = "";
  carreg = "";
  carmodel = "";
  carmake = "";
  company = "";
  parkingCheckBox = "";
  submitting = false;

  
  passtype = "password";
  showPass = false;

  /** browser upload variable */
  browser = true;
  public image : string = './assets/imgs/upload.jpeg';
  public isSelected : boolean 		=	false;
  private _SUFFIX : string;
  public upFileNm : string = '';


  /* nrowser upload var ends **/

  public imgdata : string = "";  

  validation_messages = {
    'title': [
      { type: 'required', message: '*Please choose title.' },
    ],
    'name': [
      { type: 'required', message: '*Please enter a name.' },
      //{ type: 'pattern', message: '*Please enter characters.' }
    ],
    'surname': [
      { type: 'required', message: '*Please enter a surname.' },
    ],
    'id_passport': [
      { type: 'required', message: '*Please enter an id number.' },
      { type: 'pattern', message: '*Please enter a valid id number.' },
    ],
    'email': [
      { type: 'required', message: '*Please enter an email.' },
      { type: 'pattern', message: '*Please enter a valid email.' },
    ],
    'mnumber': [
      //{ type: 'required', message: '*Please enter mobile number.' },
      { type: 'pattern', message: '*Please enter 9 digit mobile number.' }
    ],
    'password': [
      { type: 'required', message: '*Please enter a password.' },
      { type: 'minlength', message: '*Must be minimum of 8 characters length.' },
      { type: 'maxlength', message: '*Must be maximum of 30 characters length.' },
      { type: 'pattern', message: '*Atleast one letter, one capital letter, one numeric, one special character must. Please avoid sequence of numbers, characters like 123,abc,qwerty is also not valid!' },
    ],
    'cpassword': [
      { type: 'required', message: '*Please confirm your password.' },
      //{ type: 'pattern', message: '*Please enter 10 digit mobile number.' }
    ],
    'carreg': [
      { type: 'required', message: '*Please enter a car registration.' },
      //{ type: 'pattern', message: '*Please enter characters.' }
    ],
    'carmodel': [
      { type: 'required', message: '*Please enter a car model.' },
    ],
    'carmake': [
      { type: 'required', message: '*Please enter a car make.' },
    ],
    /*'company': [
      { type: 'required', message: '*Please enter a company.' },
    ], */
      
  }

  constructor( 
      private formBuilder: FormBuilder,  
      public navCtrl: NavController, 
      private toastCtrl: ToastController, 
      public navParams: NavParams,     
      public http: HttpClient,    
      private imagePicker: ImagePicker,    
      private base64: Base64,
      private camera: Camera, 
      private transfer: Transfer, 
      private file: File, 
      private filePath: FilePath, 
      public actionSheetCtrl: ActionSheetController, 
      public platform: Platform, 
      public loadingCtrl: LoadingController , 
      private _ALERT     : AlertController,
      private _IMAGES 		: ImageBrowserUploadProvider,
      public global: GlobalProvider
    ) {
    console.log(platform);
    if (this.platform.is('windows') || this.platform.is('android') || this.platform.is('ios')) {
      this.browser = false;
    }else if (this.platform.is('core') || this.platform.is('mobileweb')) {
      this.browser = true;
    }

    this.vistor_reg = this.formBuilder.group({
      title: [null],//['', Validators.required],
      name: ['', Validators.required],//, Validators.pattern('[a-zA-Z ]*')],
      surname: ['', Validators.required],
      id_passport: ['',Validators.compose([
                        Validators.required,
                        Validators.pattern('^[0-9]{13}')
                      ])
                    ],
      mnumber: ['', Validators.pattern('[0-9]{9}')],
      email: ['',Validators.compose([
                  Validators.required,
                  Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')
                ])],
      //password: ['',Validators.compose([Validators.minLength(5),Validators.required,Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]+$')])],
      //cpassword: ['',Validators.required],
      password: ['', Validators.compose([
                    Validators.required,
                    Validators.minLength(8),
                    Validators.maxLength(30),
                    //Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#%-_&*])[a-zA-Z0-9!@#%-_&*]+$')
                    Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*~()_=|<>-]).{8,30}$')
                    ])],
      cpassword: ['', Validators.compose([Validators.required])],
      carreg: [null],//'',//['', Validators.required],
      carmodel: [null],//'',//['', Validators.required],
      carmake: [null],//'',//['', Validators.required],
      company: [null]//['', Validators.required]
    }, {'validator': this.isMatching});
  }

  isMatching(group: FormGroup){

    var firstPassword = group.controls['password'].value;
    var secondPassword = group.controls['cpassword'].value;
    if((firstPassword && secondPassword) && (firstPassword != secondPassword)){
      console.log("mismatch");
      return { "pw_mismatch": true };
    } else{
      return null;
    }

  }


  public CValue:String;
  onChange(CValue) {
    const id_passportValue = this.vistor_reg.get('id_passport');
    if(CValue == 'ID'){
      id_passportValue.setValidators([Validators.pattern('^[0-9]{13}')]);
    }else if(CValue == 'PASSPORT'){
      id_passportValue.setValidators([Validators.pattern('^[a-zA-Z0-9_.+-]+$')]);
    }
    id_passportValue.updateValueAndValidity();
  }
  
  blurFunction(BValue){
    console.log('----------Blur ------------');
    console.log(BValue._value);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Accept': 'application/json'
      })
    };

    let postData = JSON.stringify({
        "password": BValue._value,
    });

    this.http.post(this.global.baseUrl+"api/admin/password", postData, httpOptions)//requestOpt)
      .subscribe((data:any) => {
        //console.log(data['_body']);
        //console.log(data);
        //console.log(data.error);
          if(data.error == true){
            //console.log(data.errorList[0].description);
            let toast = this.toastCtrl.create({
              message: data.errorList[0].description,
              duration: 5000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast');
            });
          
            toast.present();
          }else{

          }
        }, error => {

    });
  }

  showPassword(){
    this.passtype = this.passtype === 'text' ? 'password' : 'text';
    if(this.showPass){
      this.showPass = false;
    }else{
      this.showPass = true;
    }
    
  }

  
  goback(){
    this.navCtrl.pop();
  }
  
  showDisclaimer(){
    this.disclaimer = true;
  }
  hideDisclaimer(){
    this.disclaimer = false;
  }

  formMobileChanged(){
    const emailCtrl = this.vistor_reg.get('email');
    const phoneCtrl = this.vistor_reg.get('mnumber');
    this.vistor_reg.get('mnumber').valueChanges.subscribe(
      (mobileStr: string) => {
        console.log(mobileStr);
        if(mobileStr == ''){
          emailCtrl.setValidators([Validators.required]);
        }else{
          emailCtrl.clearValidators();
        }
        emailCtrl.updateValueAndValidity();
  
    });

  }

  formEmailChanged(){
    const phoneCtrl = this.vistor_reg.get('mnumber');

    this.vistor_reg.get('email').valueChanges.subscribe(
      (emailStr: string) => {
        if(emailStr == ''){
          phoneCtrl.setValidators([Validators.required]);
        }else{
          phoneCtrl.clearValidators();
        }
        phoneCtrl.updateValueAndValidity();
  
    });

  }
  
  toggleParking() {
    this.isparking = !this.isparking;

    const parkingRegCtrl = this.vistor_reg.get('carreg');
    const parkingModCtrl = this.vistor_reg.get('carmodel');
    const parkingMakCtrl = this.vistor_reg.get('carmake');
    if(this.isparking){
      parkingRegCtrl.setValidators([Validators.required]);
      parkingModCtrl.setValidators([Validators.required]);
      parkingMakCtrl.setValidators([Validators.required]);      
    }else{
      parkingRegCtrl.clearValidators();
      parkingModCtrl.clearValidators();
      parkingMakCtrl.clearValidators();
      this.vistor_reg.controls['carreg'].setValue('');
      this.vistor_reg.controls['carmodel'].setValue('');
      this.vistor_reg.controls['carmake'].setValue('');
    }

    parkingRegCtrl.updateValueAndValidity();
    parkingModCtrl.updateValueAndValidity();
    parkingMakCtrl.updateValueAndValidity();
  }

  toggleWifi() {
    this.iswifi = !this.iswifi;
  }
  toggleWheel() {
    this.iswheelChair = !this.iswheelChair;
  }

  /** image upload */
  public presentActionSheet() {
    let actionSheet = this.actionSheetCtrl.create({
      title: 'Select Image Source',
      buttons: [
        {
          text: 'Load from Library',
          handler: () => {
            this.takePicture(this.camera.PictureSourceType.PHOTOLIBRARY);
          }
        },
        {
          text: 'Use Camera',
          handler: () => {
            this.takePicture(this.camera.PictureSourceType.CAMERA);
          }
        },
        {
          text: 'Cancel',
          role: 'cancel'
        }
      ]
    });
    actionSheet.present();
  }

  public takePicture(sourceType) {
    /*this.loading = this.loadingCtrl.create({
      content: 'Uploading...',
    });
    this.loading.present();*/

    // Create options for the Camera Dialog
    var options = {
      quality: 20,
      sourceType: sourceType,
      destinationType: this.camera.DestinationType.DATA_URL,//FILE_URI,
      saveToPhotoAlbum: false,
      correctOrientation: true
    };
   
    // Get the data of an image
    this.camera.getPicture(options).then((imagePath) => {
      //console.log('In camera getpicture-----------------');
      this.imgPreview = 'data:image/jpeg;base64,' + imagePath;
      this.imgdata = imagePath;
  
      //this.loading.dismissAll()
      this.presentToast('Image succesfully uploaded.');
      //console.log(this.imgPreview);

      /*
      // Special handling for Android library
      if (this.platform.is('android') && sourceType === this.camera.PictureSourceType.PHOTOLIBRARY) {
        this.filePath.resolveNativePath(imagePath)
          .then(filePath => {
            let correctPath = filePath.substr(0, filePath.lastIndexOf('/') + 1);
            let currentName = imagePath.substring(imagePath.lastIndexOf('/') + 1, imagePath.lastIndexOf('?'));
            this.copyFileToLocalDir(correctPath, currentName, this.createFileName());
          });
      } else {
        var currentName = imagePath.substr(imagePath.lastIndexOf('/') + 1);
        var correctPath = imagePath.substr(0, imagePath.lastIndexOf('/') + 1);
        this.copyFileToLocalDir(correctPath, currentName, this.createFileName());
      }*/
    }, (err) => {
      this.presentToast('Error while selecting image.');
    });
  }

  // Create a new name for the image
  private createFileName() {
    var d = new Date(),
    n = d.getTime(),
    newFileName =  n + ".jpg";
    return newFileName;
  }
  
  // Copy the image to a local folder
  private copyFileToLocalDir(namePath, currentName, newFileName) {
    this.file.copyFile(namePath, currentName, cordova.file.dataDirectory, newFileName).then(success => {
      this.lastImage = newFileName;
      this.uploadImage();
    }, error => {
      this.presentToast('Error while storing file.');
    });
  }
  
  private presentToast(text) {
    let toast = this.toastCtrl.create({
      message: text,
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }
  
  // Always get the accurate path to your apps folder
  public pathForImage(img) {
    if (img === null) {
      return '';
    } else {
      return cordova.file.dataDirectory + img;
    }
  }

  public uploadImage() {
    // Destination URL
    var url = this.global.uploadUrl+"upload.php";//"http://192.168.1.34/upload/upload.php";
   
    // File for Upload
    var targetPath = this.pathForImage(this.lastImage);
   
    // File name only
    var filename = this.lastImage;
   
    var options = {
      fileKey: "file",
      fileName: filename,
      chunkedMode: false,
      mimeType: "multipart/form-data",
      params : {'fileName': filename}
    };
   
    const fileTransfer: TransferObject = this.transfer.create();
   
    this.loading = this.loadingCtrl.create({
      content: 'Uploading...',
    });
    this.loading.present();
   
    // Use the FileTransfer to upload the image
    fileTransfer.upload(targetPath, url, options).then(data => {
      this.loading.dismissAll()
      this.presentToast('Image succesful uploaded.');
      console.log('image success data');
      console.log(data);
      console.log('path : '+targetPath);
      console.log('file name : '+filename);
      this.imgPreview = this.global.uploadUrl+"uploads/"+filename;
    }, err => {
      this.loading.dismissAll()
      this.presentToast('Error while uploading file.');
      console.log(err);
    });
  }

  /** regiasteration upload */
  regForm(){
    
    console.log(this.vistor_reg.value);
    console.log(this.title);
    console.log(this.fname);
    this.submitting = true;

    
    //(<HTMLInputElement> document.getElementById('submitBtn')).disabled=true;
    
    //this.navCtrl.push(VisitorsRegMorePage);

    
    /*let header = new HttpHeaders({
      "Accept":'application/json',
      'Content-Type':'application/json'
    });*/
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Accept': 'application/json'
      })
    };
    //const requestOpt = new RequestOptions({ headers: header });
    var photoLink = ""
    if(this.imgPreview == './assets/imgs/upload.jpeg'){
      photoLink = "";
    }else{
      photoLink = this.imgPreview;
    }

    let postData = JSON.stringify({
      
      "visitorDTO": {
        "captureType": "visitor",
        "cars": [
          {
            "make": this.carmake,
            "model": this.carmodel,
            "registration": this.carreg
          }
        ],
        "company": this.company,
        "disclaimer": true,
        "email": this.email,
        "idNumber": this.id_passport,
        "identityType": this.id_type,
        "licenseNumber": this.id_passport,
        "matchingPassword": this.cpassword,
        "name": this.fname,
        "parking": this.isparking,
        "passport": this.id_passport,
        "password": this.password,
        "phones": [
          {
            "number": this.mnumber
          }
        ],
        "image": this.imgdata,
        "photoLocation": "",// photoLink,
        "surname": this.surname,
        "wheelChair": this.iswheelChair,
        "wifi": this.iswifi,
        "title": this.title,
      }
    
    });

    
    //console.log(postData);
    
    this.http.post(this.global.baseUrl+"api/register", postData, httpOptions)//requestOpt)
      .subscribe((data:any) => {
        //console.log(data['_body']);
        //console.log(data);
        //console.log(data.error);
          if(data.error == true){
            //console.log(data.errorList[0].description);
            let toast = this.toastCtrl.create({
              message: data.errorList[0].description,
              duration: 20000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast');
            });
          
            toast.present();
            (<HTMLInputElement> document.getElementById('regbtn')).disabled=false;
            this.disclaimer = false;
            this.submitting = false;
          }else{
            let toast = this.toastCtrl.create({
              message: 'Visitor created successfully!.',
              duration: 3000,
              position: 'bottom',
              showCloseButton:false,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast');
            });
          
            toast.present();
            //(<HTMLInputElement> document.getElementById('submitBtn')).disabled=false;
            this.navCtrl.push(LoginPage);
            this.disclaimer = false;
            this.submitting = false;
          }
        }, error => {
        console.log(error);
        let toast = this.toastCtrl.create({
          message: 'Error!.',
          duration: 3000,
          position: 'bottom',
          showCloseButton:false,
          closeButtonText:'Close'
        });

        toast.onDidDismiss(() => {
          console.log('Dismissed toast');
        });
      
        toast.present();
        this.disclaimer = false;
        this.submitting = false;
    });
  }

  /** photo capture  */
  getPhoto() {
    let options = {
      maximumImagesCount: 1
    };
    this.imagePicker.getPictures(options).then((results) => {
      for (var i = 0; i < results.length; i++) {
          this.imgPreview = results[i];
          this.base64.encodeFile(results[i]).then((base64File: string) => {
            this.regData.avatar = base64File;

            /*
            const httpOpt = {
              headers: new HttpHeaders({
                'Content-Type':  '/*',//'multipart/form-data',
                'Accept': '/*'
              })
            };
            let imgData = JSON.stringify({
              "file": this.imgPreview//base64File
            });
            this.http.post(this.global.baseUrl+"api/photo/upload", imgData, httpOpt)//requestOpt)
              .subscribe(data => {
                console.log(data['_body']);
                }, error => {
                console.log(error);
            });*/
          }, (err) => {
            console.log(err);
          });
      }
    }, (err) => { });
  }


  /** browser upload */

  /**
    * @public
    * @method selectFileToUpload
    * @param event  {any}     	The DOM event that we are capturing from the File input field
    * @description    			Handles the selection of image files from the user's computer,
    *                 			validates they are of the correct file type and displays the
    *							selected image in the component template along with an upload
    * 							button
    * @return {none}
    */

   imageblob:any;
   selectFileToUpload(event) : void
   {
    this.loading = this.loadingCtrl.create({
      content: 'Uploading...',
    });
    this.loading.present();
      this._IMAGES
      .handleImageSelection(event)
      .subscribe((res) =>
      {

         // Retrieve the file type from the base64 data URI string
         this._SUFFIX 			= res.split(':')[1].split('/')[1].split(";")[0];


         // Do we have correct file type?
         if(this._IMAGES.isCorrectFileType(this._SUFFIX))
         {

            // Hide the file input field, display the image in the component template
            // and display an upload button
            //console.log('------------------------');
            //console.log(res)
            this.isSelected 	= true
            //this.imageblob = this.dataURItoBlob(res);
            //console.log(this.imageblob);
            this.image 			= res;
            this.imgPreview = res;
            var splitted = res.split(",").pop(); 
            this.imgdata = splitted;
            //console.log(splitted);
            //this.upFileNm = 'brw_'+Date.now();
            //console.log('---------*******-------');
            //console.log(this.imgPreview)
            this.loading.dismissAll()
            this.presentToast('Image succesfully uploaded.');
            //this.uploadFile();
         }

         // If we don't alert the user
         else
         {
            this.displayAlert('You need to select an image file with one of the following types: jpg, gif or png');
            this.loading.dismissAll()
         }
      },
      (error) =>
      {
         console.dir(error);
         //this.displayAlert(error.message);
         
         this.loading.dismissAll()
         this.presentToast('Error while uploading file.');
      });
   }




   /**
    * @public
    * @method uploadFile
    * @description    			Handles uploading the selected image to the remote PHP script
    * @return {none}
    */
/*
   dataURItoBlob(dataURI) {
      // convert base64 to raw binary data held in a string
      // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
      var byteString = atob(dataURI.split(',')[1]);
      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      // write the bytes of the string to an ArrayBuffer
      var ab = new ArrayBuffer(byteString.length);
      var dw = new DataView(ab);
      for(var i = 0; i < byteString.length; i++) {
          dw.setUint8(i, byteString.charCodeAt(i));
      }
      // write the ArrayBuffer to a blob, and you're done
      
      return new Blob([ab], {type: mimeString});
  }

/*
   uploadFile() : void
   {
      this._IMAGES
      .uploadImageSelection(this.image,//this.imageblob,//
                            this._SUFFIX,
                            this.upFileNm)
      .subscribe((res) =>
      {
         //this.displayAlert(res.message);
         console.log(res.path);
         this.imgPreview = res.path;
         
         this.loading.dismissAll()
         this.presentToast('Image succesfully uploaded.');
         /*
          const httpOpt = {
            headers: new HttpHeaders({
              'Content-Type':  '/*',
              'Accept': '/*'
            })
          };
          let imgData = JSON.stringify({
            "file": res.path//base64File
          });
          this.http.post(this.global.baseUrl+"api/photo/upload", imgData, httpOpt)//requestOpt)
          .subscribe(data => {
              console.log(data['_body']);
              this.loading.dismissAll()
              this.presentToast('Image succesful uploaded.');
          }, error => {
              console.log(error);
              this.loading.dismissAll()
              this.presentToast('Error while uploading file.');
              console.log(error);
          });*
      },
      (error : any) =>
      {
         console.dir(error);
         this.displayAlert(error.message);
         this.loading.dismissAll()
      });
   }*/




   /**
    * @public
    * @method displayAlert
    * @param message  {string}  The message to be displayed to the user
    * @description    			Use the Ionic AlertController API to provide user feedback
    * @return {none}
    */
   displayAlert(message : string) : void
   {
      let alert : any   = this._ALERT.create({
         title 		: 'Heads up!',
         subTitle 	: message,
         buttons 	: ['Got it']
      });
      alert.present();
   }


}



// WEBPACK FOOTER //
// ./src/pages/visitors-reg/visitors-reg.ts